import { render, staticRenderFns } from "./BannerConfig.vue?vue&type=template&id=5db604b2&scoped=true&"
import script from "./BannerConfig.vue?vue&type=script&lang=js&"
export * from "./BannerConfig.vue?vue&type=script&lang=js&"
import style0 from "./BannerConfig.vue?vue&type=style&index=0&id=5db604b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db604b2",
  null
  
)

export default component.exports